import React, { useEffect, useState } from 'react'
import Hero from '../assets/Hero_Image.png';
import { FaTimes, FaBars, FaBlogger, FaGitlab } from 'react-icons/fa'
import { AiOutlineArrowRight } from 'react-icons/ai'
import { TbFileCertificate } from 'react-icons/tb'
import { Link } from 'react-scroll'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {
    const [navOpen, setnavOpen] = useState(false)
    const [navbarTransparent, setNavbarTransparent] = useState(true);
    const [navbarDark, setNavbarDark] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 1000) {
                setNavbarTransparent(false);
                setNavbarDark(true);
            } else if (window.pageYOffset > 50) {
                setNavbarTransparent(false);
                setNavbarDark(false);
            } else {
                setNavbarTransparent(true);
                setNavbarDark(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        AOS.init({
            duration: 500,
            easing: 'ease-in-out',
            once: true
        });
    }, []);

    const links = [
        {
            id: 1,
            emote: '🏠',
            link: 'home'
        },
        {
            id: 2,
            emote: '👦🏻',
            link: 'about'
        },
        {
            id: 3,
            emote: '📔',
            link: 'portfolio'
        },
        {
            id: 4,
            emote: '🤹🏻',
            link: 'skills'
        },
        {
            id: 5,
            emote: '📧',
            link: 'contact'
        },
    ]
    return (
        <>

            {/* ------------------------ NAVBAR -----------------------*/}

            <div
                className={`flex justify-between items-center w-full h-20 px-4 mr-4 z-40 fixed ${navbarTransparent ? 'bg-transparent' : navbarDark ? 'bg-[#023b3a]' : 'bg-[#2a5857]'
                    }`} data-aos="fade-down"
            >
                <div>
                    <h1 className='text-3xl font-logo ml-2 text-[#f9bc60]'>FitraSalam</h1>
                </div>

                <ul className='hidden md:flex'>

                    {links.map(({ id, link, emote }) => (
                        <li
                            key={id}
                            className='px-2 lg:px-4 cursor-pointer uppercase font-medium text-[#f9bc60] hover:scale-125 hover:underline hover:decoration-2 hover:underline-offset-8 hover:text-[#fffffe] duration-200'>

                            <Link to={link}
                                smooth
                                offset={-60}
                                duration={500}
                                data-aos="fade-down"
                                data-aos-delay="200"
                            >{emote} {link}
                            </Link>
                        </li>
                    )
                    )}

                </ul>

                <div onClick={() => setnavOpen(!navOpen)} className='cursor-pointer pr-3 z-10  md:hidden'>
                    {navOpen ? <FaTimes className='text-[#fffffe] hover:scale-75 duration-300' size={30} /> : <FaBars className='text-[#fffffe] hover:scale-75 duration-300' size={25} />}
                </div>

                {navOpen && (
                    <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-gray-800 to-[#004643] text-[#fffffe]'>
                        {links.map(({ id, link, emote }) => (
                            <li
                                key={id}
                                className='px-4 py-6 cursor-pointer uppercase font-bold text-[#fffffe] hover:scale-125 hover:underline hover:decoration-2 hover:underline-offset-8 duration-200'>
                                <Link to={link} smooth duration={500}>{emote} {link}</Link>
                            </li>
                        )
                        )}
                    </ul>
                )}
            </div>

            {/* ------------------------ MAIN -----------------------*/}
            <style>

                {`
                .image-container {
                    position: relative;
                    animation: up-down 2s ease-in-out infinite;
                  }
                  
                  @keyframes up-down {
                    0% {
                      transform: translateY(0);
                    }
                    50% {
                      transform: translateY(-10px);
                    }
                    100% {
                      transform: translateY(0);
                    }
                  }
                  
                    @keyframes scroll {
                        0% {
                          transform: translateY(-0%);
                        }

                        100% {
                          transform: translateY(-300%);
                        }
                      }
                      
                      .animate-scroll {
                        animation: scroll 10s ease-in-out infinite;
                      }

                      @keyframes wave-hand {
                        0% {
                          transform: rotate(0deg);
                        }
                                            
                        50% {
                          transform: rotate(40deg);
                        }
                   
                        100% {
                          transform: rotate(0deg);
                        }
                      }
                      
                      .wave-hand {
                        display: inline-block;
                        animation: wave-hand 2s infinite;
                        transform-origin: 70% 70%;
                      }
                      
                      
                    `}
            </style>
            <div name="home" className='pt-[90px] pr-3 pl-4 lg:pl-6 lg:pr-1 sm:pr-3 mb-6 h-auto w-full bg-gradient-to-b from-[#004643] via-[#abd1c6] to-slate-50'>
                <div className='max-w-screen-lg mx-auto flex flex-col-reverse items-center justify-center h-full md:flex-row'>
                    <div className='flex flex-col justify-center h-full' data-aos="fade-up-right" data-aos-delay="200" data-aos-once="true">
                        <h2 className='text-4xl text-[#fffffe] sm:text-7xl font-extrabold'><span className='wave-hand'>👋</span> Hi, I'm <br /> <span className={`hello ${navOpen ? 'hidden' : ''}`}>FitraSalam</span>,</h2>

                        <div className='flex pt-3 font-logo h-[40px] text-lg sm:text-md'>
                            <p className='w-[5.875rem]'>I'm a</p>
                            <div className='grid w-[100%] overflow-hidden'>
                                <span className='animate-scroll ease-linear text-[#001e1d]'>Front-End Developer</span>
                                <span className='animate-scroll ease-linear text-[#001e1d]'>UI/UX Designer</span>
                                <span className='animate-scroll ease-linear text-[#001e1d]'>Blogger</span>
                            </div>
                        </div>
                        {/* <h2 className='pt-4 text-xl font-logo sm:text-md'>Front-End Developer</h2> */}
                        <p className='py-2 text-[#001e1d] max-w-md'>Hi there! I am a Front-End Developer and UI/UX Designer with a passion for creating engaging and intuitive digital experiences.
                            I am comfortable working with a variety of programming languages and frameworks. I have been working on various personal projects that have given me a deep understanding of the development and design process.
                            My goal is to use my skills to help bring innovative ideas to life and to continuously improve my craft.
                        </p>

                        <div className="items-center justify-start space-x-2 w-full p-2 flex lg:hidden">

                            <a href='https://www.linkedin.com/in/fitrasalam/' target='_blank' rel='noreferrer'>
                                {/* Linkedin */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 pr-1 hover:scale-110 cursor-pointer" fill="currentColor" style={{ color: '#0077b5' }} viewBox="0 0 24 24">
                                    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                                </svg>
                            </a>

                            <a href='https://github.com/alamnaga' target='_blank' rel='noreferrer'>
                                {/* Github */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 pr-2 hover:scale-110 cursor-pointer" fill="currentColor" style={{ color: '#333' }} viewBox="0 0 24 24">
                                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                                </svg>
                            </a>

                            <a href='https://gitlab.com/alamnaga' target='_blank' rel='noreferrer'>
                                <FaGitlab className="pr-1 hover:scale-110 cursor-pointer fill-[#e34329]" size={30} />
                            </a>

                            <a href='https://www.instagram.com/snagalay/' target='_blank' rel='noreferrer'>
                                {/* Instagram */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 pr-2 hover:scale-110 cursor-pointer" fill="currentColor" style={{ color: '#c13584' }} viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                </svg>
                            </a>

                            <a href='https://alamnaga.blogspot.com/' target='_blank' rel='noreferrer'>
                                <FaBlogger className="pr-1 hover:scale-110 cursor-pointer fill-[#f16100]" size={30} />

                            </a>

                            <a href='https://dribbble.com/alamnaga' target='_blank' rel='noreferrer'>
                                {/* Dribbble */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 pr-2 hover:scale-110 cursor-pointer" fill="currentColor" style={{ color: '#ea4c89' }} viewBox="0 0 24 24">
                                    <path d="M12 0c-6.628 0-12 5.373-12 12s5.372 12 12 12 12-5.373 12-12-5.372-12-12-12zm9.885 11.441c-2.575-.422-4.943-.445-7.103-.073-.244-.563-.497-1.125-.767-1.68 2.31-1 4.165-2.358 5.548-4.082 1.35 1.594 2.197 3.619 2.322 5.835zm-3.842-7.282c-1.205 1.554-2.868 2.783-4.986 3.68-1.016-1.861-2.178-3.676-3.488-5.438.779-.197 1.591-.314 2.431-.314 2.275 0 4.368.779 6.043 2.072zm-10.516-.993c1.331 1.742 2.511 3.538 3.537 5.381-2.43.715-5.331 1.082-8.684 1.105.692-2.835 2.601-5.193 5.147-6.486zm-5.44 8.834l.013-.256c3.849-.005 7.169-.448 9.95-1.322.233.475.456.952.67 1.432-3.38 1.057-6.165 3.222-8.337 6.48-1.432-1.719-2.296-3.927-2.296-6.334zm3.829 7.81c1.969-3.088 4.482-5.098 7.598-6.027.928 2.42 1.609 4.91 2.043 7.46-3.349 1.291-6.953.666-9.641-1.433zm11.586.43c-.438-2.353-1.08-4.653-1.92-6.897 1.876-.265 3.94-.196 6.199.196-.437 2.786-2.028 5.192-4.279 6.701z" />
                                </svg>
                            </a>


                        </div>


                        <div className="mb-9 mt-2 flex flex-col justify-center items-start md:flex-row md:justify-start">
                            <button className="cursor-pointer group text-[#001e1d] font-semibold w-fit px-4 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-[#fde680] to-[#ffb647] hover:scale-105 duration-300 md:mr-4 md:my-0"
                                data-aos="zoom-in-up" data-aos-delay="200" data-aos-once="true"
                                onClick={() => window.open('https://docs.google.com/document/d/1u32LXzoghw2qpskSql1ZEEKoYQ5UXNF-UDEgHpRd1gU/edit?usp=sharing', '_blank')}>
                                Curriculum Vitae
                                <span className="group-hover:scale-75 duration-300">
                                    <AiOutlineArrowRight className="ml-2" size={18} />
                                </span>
                            </button>
                            <button className="group px-4 py-3 font-semibold duration-200 bg-[#e16162] flex items-center  rounded-md text-[#fffffe] w-fit md:w-auto"
                                data-aos="zoom-in-up" data-aos-delay="200" data-aos-once="true"
                                onClick={() => window.open('https://drive.google.com/drive/folders/1oJO9IZFKT6Mr9Iy-0R8IVbN6Dv8tyUGB?usp=sharing', '_blank')}>
                                My Certificate
                                <span className="group-hover:scale-75 duration-300">
                                    <TbFileCertificate className="ml-2" size={18} />
                                </span>
                            </button>
                        </div>

                    </div>

                    <div className='pb-2' data-aos="fade-up-left" data-aos-delay="200" data-aos-once="true">
                        <div className="image-container">
                            <img src={Hero} alt="Profile" className='hover:scale-x-105 hover:rotate-2 duration-200 rounded-2xl mx-auto w-2/3 md:w-3/4' />
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Home